import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import AudioPlayer from "Components/Common/AudioPlayer";
import MediaUploader from "Components/Common/MediaUploader";
import SpecialPriceSelector from "Components/Common/SpecialPriceSelector";
import VideoUploader from "Components/Common/VideoUploader";
import { Media } from "helpers/models/media.model";
import { PackageDTO } from "helpers/models/package.model";
import { AddProductDTO } from "helpers/models/product.model";
import { SubProduct, SubVariants } from "helpers/models/subproduct.model";
import { Variants, VariantValuesDTO } from "helpers/models/variant.model";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast, ToastContainer } from 'react-toastify';
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Col,
    Form,
    FormFeedback,
    Input,
    Label,
    ListGroup,
    ListGroupItem,
    Row,
    Table,
    UncontrolledTooltip,
    Spinner,
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { createSelector } from "reselect";
import { getKeyForFormField, resolveFieldValue } from "utils/helperfunctions";
import { appendCategoryList, getCategoriesByNameAI, getCategoriesSelectFunc } from "../../../../../live-slices/category/thunk";
import { addProductDraftFromJSON, addProductFromJSON, deleteProduct, fetchProductForEdit, updateProductFromJSON, updateDraftProductFromJSON, fetchProductDraftDetail, deleteDraftProductApi, fetchProductAiData } from "../../../../../live-slices/products/thunk";
import { CategorySelectInput } from "./CategorySelector";
import Loader from "Components/Common/Loader";
import DeleteModal from "Components/Common/DeleteModal";
import { FirebaseAuthBackend, getFirebaseBackend } from "helpers/firebase_helper";
import { StorageKeys } from "utils/enums";
import { clearForm } from "slices/category/reducer";
import { getBrandCategoryIdByThunk, getBrandThunk } from "live-slices/thunk";
import CreatableSelect from "react-select/creatable";
import defaultForms from 'utils/json';
import defaultVariantsForms from 'utils/defaultVariants'
import ErrorModal from "Components/Common/ErrorModal";
import TermsPrivacyPopup from "Components/Common/termAndConditions";
import star from"../../../../../assets/images/ttStart.svg"

const SubProductAvailability = {
    "important": false,
    "name": "isAvailable",
    "uiType": "toggle",
    "label": "Availablility",
    "placeholder": "Is Available",
    "required": false,
    "sticky": true,
    "info": {
        "help": "Identifier for a product provieded by the Seller. Product is mandatory for Seller, even when the column \\Mandaroy\\ says something different."
    }
};

class MyUploadAdapter {
    firebaseHelper: FirebaseAuthBackend | null = getFirebaseBackend();

    loader: any;
    constructor(loader: any) {
        this.loader = loader;
    }
    // Starts the upload process.
    upload() {
        return this.loader.file.then(
            (file: any) =>
                new Promise(async (resolve, reject) => {

                    const url = await this.firebaseHelper?.uploadImage(file, "product/");
                    if (url) {
                        resolve({ default: url })
                    }
                    else {
                        reject("no url uploaded")
                    }

                })
        );
    }
}

let successTimeout: any;

interface AddProductStepOneProps {
    draftId?: string;
    productId: string;
    onButtonRes?: (res: boolean) => void
}

// Child Component
const AddProductStepOne = forwardRef(({ draftId, productId, onButtonRes = (val) => { } }: AddProductStepOneProps, ref,) => {
    const dispatch: any = useDispatch();
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [weightage, setWeightage] = useState<any>();
    const [dimension, setDimension] = useState<any>();
    const [productData, setProductData] = useState<any>({});
    const [importantFieldsShown, setImportantFieldsShown] = useState<string[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<any>([])
    // Inside your component
    const [isAdditionalField, setIsAdditionalField] = useState(false);
    // const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isCategoryLoading, setIsCategoryLoading] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});
    const formRef = useRef<HTMLFormElement | null>(null)
    const [customVariantTypeAdded, setCustomVariantTypeAdded] = useState(false);
    const [editingVariantType, setEditingVariantType] = useState(false);
    const firebaseHelper: FirebaseAuthBackend | null = getFirebaseBackend();
    const [showModal, setShowModal] = useState(false);
    const location = useLocation();
    const [inputCategory, setInputCategory] = useState("");
    const [termAndConditonModal, setTermAndConditonModal] = useState(false);
    const [manualVariants, setManualVariants] = useState<Variants[]>([]);
    const [aiData, setAiData] = useState<any>(null);
    const [showProductNameOption, setShowProductNameOption] = useState(true); // 👁️ Show/hide tick option
    const [userDecisionMade, setUserDecisionMade] = useState(false); 
    const [showProductDescriptionOption, setShowProductDescriptionOption] = useState(true);
    const [userDescriptionDecisionMade, setUserDescriptionDecisionMade] = useState(false);
    const [showWeightOption, setShowWeightOption] = useState(true);
    const [userWeightDecisionMade, setUserWeightDecisionMade] = useState(false);

    const skipLabels = ['Main Description', "Highlights", "What's in the box", "Package Length(cm) * Width(cm) * Height(cm)"];
    // 'Package Weight',
    const prevUrlRef = useRef<string | null>(null);
    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );

    const user = useSelector(selectUser);
    const uploaderRef = useRef<HTMLDivElement | null>(null); // Correctly typed ref
    // const selectRef = useRef<HTMLSelectElement | null>(null);



    const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);
    const [errorMessageColor, setErrorMessageColor] = useState<string>("");
    const [showModalColor, setShowModalColor] = useState({
        isVisible: false,
        color: false,
    });

    const DEBOUNCE_DELAY = 200;
    const [currentBindingKey, setCurrentBindingKey] = useState<string | null>(Date.now().toString());

    const generateKey = () => {
        setCurrentBindingKey(Date.now().toString());
        // initizializeVariantIfNot(forms);
        console.log("Key generated:", currentBindingKey);
    }


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // const validValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
        const validValue = e.target.value;
        updateProductData('nameEn', validValue);

        console.log(validValue.length);

        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        if (validValue.length > 4) {
            const timeout = setTimeout(() => {
                dispatch(getCategoriesByNameAI(validValue));
            }, DEBOUNCE_DELAY);
            setDebounceTimeout(timeout);
        }
    };


    useImperativeHandle(ref, () => ({
        clickButton: () => {
            if (buttonRef.current) {
                buttonRef.current.click();
            }
        },
    }));
    const Selectbrand = createSelector(
        (state: any) => state.Brands,
        (brands) => brands?.brands || []
    );

    const brands = useSelector(Selectbrand);

    const handleScrollToSelect = () => {
        // if (selectRef.current) {
        //     selectRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        //     selectRef.current.focus();
        // }
    };

    const uploadContentToFirebase = async (content: any) => {

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = content;
        const images: any = tempDiv.getElementsByTagName("img");
        for (const img of images) {
            const imageSrc = img.getAttribute("src");
            if (imageSrc && (imageSrc.startsWith("data:") || imageSrc.startsWith("blob:") || imageSrc.startsWith("http:") || imageSrc.startsWith("https:"))) {
                try {
                    console.log("Fetching image: ", imageSrc);
                    const imageBlob = await fetch(imageSrc)
                        .then((res) => {
                            if (!res.ok) {
                                throw new Error(`Failed to fetch image: ${res.statusText}`);
                            }
                            return res.blob();
                        });
                    if (!imageBlob) {
                        throw new Error("Failed to fetch image as blob");
                    }
                    console.log("Image fetched successfully: ", imageSrc);
                    const firebaseUrl = await firebaseHelper?.uploadImage(imageBlob, "content/");
                    if (firebaseUrl) {
                        console.log("Firebase URL: ", firebaseUrl);
                        img.setAttribute("src", firebaseUrl);
                    }
                } catch (error) {
                    console.error("Error uploading image:", imageSrc, error);
                }
            } else {
                console.warn("Invalid image source, skipping: ", imageSrc);
            }
        }

        return tempDiv.innerHTML;
    };

    const handleProductDraftResponse = (response: any) => {
        setIsCategoryLoading(false);
        if (response.payload) {
            let form = defaultForms;
            if (response.payload.categoryForm) {
                form = response.payload.categoryForm.configData
            }
            setForms(form);
            const category = response.payload.category;
            if (category) {
                dispatch(getBrandCategoryIdByThunk({ categoryId: category.idPath[0] }));
            }
            dispatch(appendCategoryList(category));
                    setSelectedCategory(category);
                    let prodData = AddProductDTO.parse(form, (response.payload.product||response.payload.draft));
                    if (prodData) {
                        setProductData(prodData);
                        if (prodData.nameUr) {
                            setIsAdditionalField(true);
                        }
                    }
                } else {
                    toast.error("Cannot fetch product");
                }
        }

        useEffect(() => {
            if (draftId) {
                setIsCategoryLoading(true);
                dispatch(fetchProductDraftDetail(draftId)).then((response: any) => handleProductDraftResponse(response));
        }
    }, [draftId]);

    useEffect(() => {
        if (productId) {
            setIsCategoryLoading(true);
            dispatch(fetchProductForEdit(productId)).then((response: any) => handleProductDraftResponse(response));
        }
    }, [productId]);
    const [forms, setForms] = useState<Form[]>([]);


    const selectFormData = createSelector(
        (state: any) => state.Category,
        (form) => form?.form
    );
    const categoryForm = useSelector(selectFormData);

    const navigate = useNavigate();
    const [isSubmitted, setIsSubmitted] = useState(false);
    useEffect(() => {
        if (!showModal) {
            if (productId || draftId) {
                return 
            }
            if (productData && Object.keys(productData).length) {
                localStorage.setItem(StorageKeys.productFormData, JSON.stringify(productData));
            }
        }
        if (isSubmitted) {
            isFormValid();
        }
    }, [productData])

    const hasSubmittedRef = useRef(false);
    const acceptedFromPopupRef = useRef(false);
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
    if (
        user?.storeStatus?.isPrivacyPolicyRead &&
        !hasSubmittedRef.current &&
        acceptedFromPopupRef.current
    ) {
        hasSubmittedRef.current = true;
        onProductSubmit();
    }
    }, [user, accepted]);





  useEffect(() => {
  const currentUrl = productData?.productImages?.[0]?.url?.trim();
  const cleanUrl = currentUrl?.replace(/^"+|"+$/g, '');

  if (cleanUrl && prevUrlRef.current !== cleanUrl) {
    prevUrlRef.current = cleanUrl;

    dispatch(fetchProductAiData(cleanUrl))
      .unwrap()
      .then((data: any) => {
        console.log("AI Data:", data);
        setAiData(data);
        if (data?.productName) {
        setShowProductNameOption(true);
        setUserDecisionMade(false);
    }
    if (data?.productDescription) {
        setShowProductDescriptionOption(true);
        setUserDescriptionDecisionMade(false);
    }
    if (data?.productWeight || data?.weight) {
        setShowWeightOption(true);
        setUserWeightDecisionMade(false);
    }
      });
  }
}, [productData?.productImages]);



    useEffect(() => {
        if (productData && Object.keys(productData).length) {
            if (categoryForm && categoryForm.length) {
                localStorage.setItem(StorageKeys.productCategoryForm, JSON.stringify(categoryForm));
                setForms(categoryForm);
            } else {
                if (selectedCategory.leaf) {
                    localStorage.setItem(StorageKeys.productCategoryForm, JSON.stringify(defaultForms));
                    setForms(defaultForms);
                } else {
                    setShowModalColor({ isVisible: true, color: false });
                    setErrorMessageColor(`Please Select leaf category`)
                    setTimeout(() => {
                        setShowModalColor({ isVisible: false, color: false });
                    },
                        2000);
                }
            }
            setIsCategoryLoading(false);
        }
    }, [categoryForm]);


    useEffect(() => {
        if (productData && Object.keys(productData).length) {
            if (!productId) {
                initizializeVariantIfNot(categoryForm);
            }
            else if (!draftId) {
                initizializeVariantIfNot(categoryForm);
            }
            setProductWeightData();
            setProductDimensionData();
        }
    }, [forms])

    const setProductWeightData = () => {
        if (!forms || !Array.isArray(forms)) {
            console.log("Error: 'forms' is undefined or not an array.");
            return;
        }

        const productWeightageField = forms.find((x: any) => x.name === "logisticsWeight");
        if (!productWeightageField) {
            console.log("Warning: 'logisticsWeight' field not found in 'forms'.");
            return;
        }

        setWeightage(productWeightageField);
    };


    const setProductDimensionData = () => {
        if (!forms || !Array.isArray(forms)) {
            console.log("Error: 'forms' is undefined or not an array.");
            return;
        }

        const productDimensionField = forms.find((x: any) => x.name === "logisticsSize");
        if (!productDimensionField) {
            console.log("Warning: 'logisticsSize' field not found in 'forms'.");
            return;
        }

        setDimension(productDimensionField);
    };

    useEffect(() => {
        onButtonRes(loader);
    }, [loader, onButtonRes])



    const [hasSubmitted, setHasSubmitted] = useState(false);

    const onProductSubmit = () => {
        if (loader || hasSubmitted) return;

        setLoader(true);
        const isValid = isFormValid();
        let jsonToPass = { ...productData };
        delete jsonToPass.promotionWhiteImageBg;
        const hasInvalidStock = jsonToPass.subProducts?.some(
            (sub: any) => sub.Stock < 0
        );

        if (hasInvalidStock) {
            setShowModalColor({ isVisible: true, color: false });
            setErrorMessageColor("Sub-products cannot have negative stock values. Please correct them before submitting.")
            setTimeout(() => {
                setShowModalColor({ isVisible: false, color: false });
            }, 3000);
            setLoader(false);
            return false;
        }

        if (Array.isArray(jsonToPass.variants)) {
            jsonToPass.variants = jsonToPass.variants.filter(
                (v: any) => Array.isArray(v.values) && v.values.length > 0
            );
        }

        if (!jsonToPass.productImages) {
            jsonToPass.productImages = [];
        }
        if (draftId) {
            jsonToPass.draftId = draftId;
        }

        if (!productId && (!jsonToPass["Warranty Type"] || jsonToPass["Warranty Type"] === "")) {
            jsonToPass["Warranty Type"] = "No Warranty";
        }

        if (!isValid) {
            if (errors && errors.productImages && uploaderRef.current) {
                uploaderRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            handleScrollToSelect();
            setLoader(false);
            return false;
        }
        if (!user?.storeStatus?.isPrivacyPolicyRead) {
            setTermAndConditonModal(true);
            setLoader(false);
            return;
        }

        // Use a flag to prevent multiple submissions until navigation
        let submitted = false;

        const handleResponse = (payload: any, successMsg: string, failMsg: string) => {
            if (submitted) return;
            submitted = true;
            setHasSubmitted(true); // Prevent further submissions
            if (payload?.isSuccess) {
                setShowModalColor({ isVisible: true, color: false });
                setErrorMessageColor(successMsg)
                setTimeout(() => {
                    setShowModalColor({ isVisible: false, color: false });
                }, 2000);
                handleSuccessFlow(payload);
            } else {
                setShowModalColor({ isVisible: true, color: false });
                setErrorMessageColor(payload?.message || failMsg)
                setTimeout(() => {
                    setShowModalColor({ isVisible: false, color: false });
                }, 2000);
                setLoader(false);
                setHasSubmitted(false);
            }
        };

        if (productId) {
            dispatch(updateProductFromJSON({ productId, formData: jsonToPass }))
                .then((res: any) => {
                    handleResponse(res.payload, "Product updated successfully!", "Failed to update product.");
                    // setLoader(false); // Loader will be reset after navigation
                    return true;
                })
                .catch(() => {
                    if (!submitted) {
                        setShowModalColor({ isVisible: true, color: true });
                        setErrorMessageColor("Something went wrong during update.")
                        setTimeout(() => {
                            setShowModalColor({ isVisible: false, color: true });
                        }, 2000);
                        setLoader(false);
                        setHasSubmitted(false);
                    }
                });
        } else {
            dispatch(addProductFromJSON(jsonToPass))
                .then((res: any) => {
                    handleResponse(res.payload, "Product added successfully!", "Failed to add product.");
                    // setLoader(false); // Loader will be reset after navigation
                    return true;
                })
                .catch(() => {
                    if (!submitted) {
                        setShowModalColor({ isVisible: true, color: false });
                        setErrorMessageColor("Something went wrong during add.")
                        setTimeout(() => {
                            setShowModalColor({ isVisible: false, color: false });
                        }, 2000);
                        setLoader(false);
                        setHasSubmitted(false);
                    }
                });
        }
    };

    // Reset hasSubmitted when navigated away (to allow new submissions)
    useEffect(() => {
        return () => {
            setHasSubmitted(false);
        };
    }, [productId, draftId, navigate]);

    const onDraftSubmit = () => {
        console.log(loader, "check on on submit");
        setLoader(true);
        let jsonToPass = productData;
        if (!jsonToPass.productImages) {
            jsonToPass.productImages = [];
        }

        if (draftId) {
            dispatch(updateDraftProductFromJSON({ draftId, formData: jsonToPass })).then((res: any) => {
                const payload = res.payload;
                handleSuccessFlowDraft(payload);
                // isValue = true;
                return true
                console.log(loader, "check on is submit");


            }).catch((e: any) => {
                setLoader(false);

            })
        } else {
            setLoader(true)
            dispatch(addProductDraftFromJSON(jsonToPass)).then((res: any) => {
                const payload = res.payload;
                handleSuccessFlowDraft(payload);
            }).catch((e: any) => {
                setLoader(false);
            })
        }
        return false;
    }

    const handleSuccessFlow = (productResponse: any) => {
        // setLoader(false);
        // setIsLoading(false);
        try {
            if (productResponse.isSuccess) {
                sessionStorage.removeItem("categoryid");
                // toast.success(productResponse.message || "Product Added!"
                setShowModalColor({ isVisible: true, color: true });
                setErrorMessageColor(productResponse.message || "Product Added!.")
                setTimeout(() => {
                    setShowModalColor({ isVisible: false, color: true });
                }, 2000);
                setTimeout(() => {
                    setProductData({});
                    handleDiscard()
                    if (draftId) {
                        navigate('/draft-products');
                    }
                    else {
                        navigate('/manage-products');
                    }
                }, 2000);
            } else {
                setLoader(false)
                // toast.error(productResponse.message || "Error! Submitting product form.");
                setShowModalColor({ isVisible: true, color: true });
                setErrorMessageColor(productResponse.message || "Error! Submitting product form.")
                setTimeout(() => {
                    setShowModalColor({ isVisible: false, color: true });
                }, 2000);
            }
        } catch (e) {
            setLoader(false)
            console.error("Error add product", e);

        }
    };

    const handleSuccessFlowDraft = (draftResponse: any) => {
        // setLoader(false);
        // setIsLoading(false);
        try {
            if (draftResponse.isSuccess) {
                setShowModalColor({ isVisible: true, color: true });
                setErrorMessageColor(draftResponse.message || "Product Added!")
                setTimeout(() => {
                    setShowModalColor({ isVisible: false, color: true });
                }, 2000);
                // toast.success(draftResponse.message || "Product Added!", {
                //     position: "top-right",
                //     autoClose: 1500,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "colored",
                // });
                setTimeout(() => {
                    setProductData({});
                    handleDiscard()
                    navigate('/draft-products');
                }, 2000);
            } else {
                setLoader(false)
                setShowModalColor({ isVisible: true, color: false });
                setErrorMessageColor(draftResponse.message || "Error! Submitting product form.")
                setTimeout(() => {
                    setShowModalColor({ isVisible: false, color: true });
                }, 2000);
            }
        } catch (e) {
            setLoader(false)
            console.error("Error add product", e);

        }
    };

    const togglenameUr = () => {
        setIsAdditionalField(!isAdditionalField);
    };




    const handleTypeChange = (selected: any) => {
        if (selected.type === "Variant") {
            setEditingVariantType(false);
        } else {
            setEditingVariantType(true);
        }
    };


    const handleCheckboxChange = (data: any, key: string, value: any, isMultiple: boolean) => {
        if (isMultiple) {
            if (!Array.isArray(data[key])) {
                data[key] = [];
            }
            if (data[key].includes(value)) {
                data[key].splice(data[key].indexOf(value), 1);
            } else {
                data[key].push(value);
            }
        } else {
            data[key] = value;
        }
    }

    const onCheckboxChange = (key: string, value: any, isMultiple: boolean = false) => {
        let data = { ...productData };
        if (key.includes('.')) {
            const keys = key.split('.');
            const lastKey = keys.pop()!;
            let current = data;
            keys.forEach((k) => {
                current[k] = current[k] || {};
                current = current[k];
            });
            handleCheckboxChange(current, lastKey, value, isMultiple);
        } else {
            handleCheckboxChange(data, key, value, isMultiple);
        }
        setProductData(data);
    }
    const [customInputs, setCustomInputs] = useState<{ [key: number]: string }>({});
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    useEffect(() => {
        if (forms && Array.isArray(forms) && forms.length > 0) {
            initizializeVariantIfNot(forms);
        } else {
            initizializeVariantIfNot(defaultVariantsForms);
        }
    }, [forms]);

   const initizializeVariantIfNot = (forms: any) => {
        if (!productData.categoryId) {
            return;
        }
        try {
        let variants: Variants[] = [];
        generateKey();
        const formVariants =
            Array.isArray(forms) && forms.length > 0
                ? forms.find((x: any) => x.name === "customSaleProp")
                : null;

        if (
            formVariants &&
            (!Array.isArray(formVariants.dataSource) || formVariants.dataSource.length === 0)
        ) {
            variants = [
                {
                    type: "Variant",
                    subType: "",
                    allowImages: false,
                    options: [
                        { label: "➕ Add New Variant", value: "__add_new__" },
                    ],
                    values: [],
                    fromManual: true
                },
                //    {
                //             type: "Variant",
                //             subType: "",
                //             allowImages: false,
                //             options: [
                //                 { label: "➕ Add New Variant", value: "__add_new__" },
                //             ],
                //             values: [],
                //         },
            ];
            setProductData((prevProductData: any) => ({
                ...prevProductData,
                variants
            }));
            setSubProducts();
            generateKey();
            return;
        }

        if (!productId && formVariants && Array.isArray(formVariants.dataSource) && formVariants.dataSource.length > 0) {
            formVariants.dataSource.forEach((variantItem: any) => {
                let attribute =
                    formVariants.attributes && Array.isArray(formVariants.attributes)
                        ? formVariants.attributes.find((x: any) => x.name === variantItem.name)
                        : null;

                let dataSource = attribute?.dataSource || [];
                let options = Array.isArray(dataSource)
                    ? dataSource.map((x: any) => ({
                        label: x.text,
                        value: x.text,
                    }))
                    : [];

                variants.push({
                    type: variantItem.text,
                    subType: "",
                    allowImages: false,
                    options: options.length
                        ? options
                        : [{ label: "➕ Add New Variant", value: "_add_new_" }],
                    values: [],
                    fromManual: false,
                });
            });
            setProductData((prevProductData: any) => ({
                ...prevProductData,
                variants
            }));

            const shouldRenderSubProducts = variants.every((variant: any) => {
                const valuesEmpty =
                    !Array.isArray(variant.values) || variant.values.length === 0;
                const optionsOnlyAddNew =
                    Array.isArray(variant.options) && variant.options.length > 0
                        ? variant.options.every(
                            (opt: any) =>
                                opt.value === "add_new" || opt.value === "_add_new_"
                        )
                        : true;

                return valuesEmpty && optionsOnlyAddNew;
            });

            if (shouldRenderSubProducts) {
                setSubProducts();
            }

            generateKey();
            return;
        }

        let allVariantTypes: string[] = [];
        if (formVariants && Array.isArray(formVariants.dataSource)) {
            allVariantTypes = formVariants.dataSource.map((v: any) => v.text);
        }

        let productVariantTypes: string[] = [];
        let validVariants: any[] = [];
        let subProductVariantTypes: string[] = [];
        if (Array.isArray(productData.subProducts)) {
            productData.subProducts.forEach((sp: any) => {
                if (Array.isArray(sp.variants)) {
                    sp.variants.forEach((v: any) => {
                        if (v && v.name && !subProductVariantTypes.includes(v.name)) {
                            subProductVariantTypes.push(v.name);
                        }
                    });
                }
            });
        }

        if (!productData.variants) {
            const mergedVariantTypes = Array.from(
                new Set([...allVariantTypes, ...productVariantTypes, ...subProductVariantTypes])
            );

            mergedVariantTypes.forEach((variantType) => {
                let formVariant: any = null;
                if (formVariants && Array.isArray(formVariants.dataSource)) {
                    formVariant = formVariants.dataSource.find(
                        (v: any) => v.text === variantType
                    );
                }

                let attribute =
                    formVariants && Array.isArray(formVariants.attributes)
                        ? formVariants.attributes.find(
                            (x: any) => x.name === (formVariant?.name || variantType)
                        )
                        : null;

                let dataSource = attribute?.dataSource || [];
                let variantValues = validVariants?.find(
                    (x: any) => x.type?.toLowerCase() === variantType.toLowerCase()
                );

                let values: any[] = [];
                if (variantValues?.values?.length) {
                    values = variantValues.values;
                } else if (Array.isArray(productData.subProducts)) {
                    let subValues: any[] = [];
                    productData.subProducts.forEach((sp: any) => {
                        if (Array.isArray(sp.variants)) {
                            sp.variants.forEach((v: any) => {
                                if (v && v.name && v.name === variantType) {
                                    if (!subValues.some((sv) => sv.name === v.value)) {
                                        subValues.push({ name: v.value, images: [] });
                                    }
                                }
                            });
                        }
                    });
                    values = subValues;
                }

                if (!values.length && Array.isArray(productData.subProducts)) {
                    let subValues: any[] = [];
                    productData.subProducts.forEach((sp: any) => {
                        if (sp.id && sp.id === variantType) {
                            if (!subValues.some((sv) => sv.name === sp.id)) {
                                subValues.push({ name: sp.id, images: [] });
                            }
                        }
                    });
                    if (subValues.length) values = subValues;
                }
                let allowImages = variantValues?.allowImages || false;
                let options = Array.isArray(dataSource)
                    ? dataSource.map((x: any) => ({
                        label: x.text,
                        value: x.text,
                    }))
                    : [];

                let fromManual = !formVariant;

                variants.push({
                    type: variantType,
                    subType: "",
                    allowImages,
                    options: options.length
                        ? options
                        : [{ label: "➕ Add New Variant", value: "_add_new_" }],
                    values,
                    fromManual,
                });
            });

        }

        if (!variants.length) {
            if (
                Array.isArray(productData.variants) &&
                productData.variants.length > 0
            ) {
                const validVariants = productData.variants.filter(
                    (variant: any) =>
                        variant &&
                        Object.keys(variant).length > 0 &&
                        Array.isArray(variant.values) &&
                        variant.values.length > 0
                );

                if (validVariants.length > 0) {
                    variants = validVariants;
                }
            } else {
                    variants = [
                        {
                            type: "Variant",
                            subType: "",
                            allowImages: false,
                            options: [
                                { label: "➕ Add New Variant", value: "__add_new__" },
                            ],
                            values: [],
                            fromManual: true
                        },
                        // {
                        //     type: "Storage Capacity",
                        //     subType: "",
                        //     allowImages: false,
                        //     options: [
                        //         { label: "➕ Add Capacity", value: "__add_new__" },
                        //     ],
                        //     values: [],
                        // },
                    ];
                }
            }

            setProductData((prevProductData: any) => ({
                ...prevProductData,
                variants
            }));
            const shouldRenderSubProducts = variants.every((variant: any) => {
            const valuesEmpty = !Array.isArray(variant.values) || variant.values.length === 0;
            const optionsOnlyAddNew =
            Array.isArray(variant.options) && variant.options.length > 0
            ? variant.options.every((opt: any) =>
                opt.value === '_add_new_' || opt.value === '__add_new__'
                )
            : true;

            return valuesEmpty && optionsOnlyAddNew;
            });
            if (shouldRenderSubProducts) {
            setSubProducts();
            }
        generateKey();
        } catch (error) {
            console.log("Error in initializeVariantIfNot:", error);
        }
    };



    const updateProductVariantImageCheck = (index: number, value: boolean) => {
        let variants = [...productData.variants];
        if (!value) {
            variants = variants.map((v) => ({ ...v, allowImages: false }));
            variants[index] = {
                ...variants[index],
                values: variants[index].values.map((val: any) => ({
                    ...val,
                    images: [], 
                })),
            };

            setSelectedIndex(null);
        } else {
            variants = variants.map((v, i) => ({
                ...v,
                allowImages: i === index,
            }));
            setSelectedIndex(index);
        }

        setProductData((prev: any) => ({
            ...prev,
            variants,
        }));
    };


    const onVariantSelect = (index: number, valueIndex: number, selection: any) => {
        
        let variants = [...productData.variants];
        let variantValue = new VariantValuesDTO(
            (selection?.label === "➕ Add New Variant" || selection?.label === "➕ Add Capacity")
                ? ""
                : selection?.label || ""
        );

        const variantName = selection?.label || "";
        const alreadyExists = variants[index].values.some(
            (v: any) => v?.name?.toLowerCase() === variantName.toLowerCase()
        );

        if (alreadyExists) {
                setShowModalColor({ isVisible: true, color: false });
                setErrorMessageColor(`"${variantName}" is already added in this variant.`)
                setTimeout(() => {
                setShowModalColor({ isVisible: false, color: false });
                }, 2000);
            return;
        }
        if (valueIndex === -1) {
            variants[index].values.push(variantValue);
        } else {
            const existingImages = variants[index].values[valueIndex]?.images || [];
            variantValue.images = existingImages;
            variants[index].values[valueIndex] = variantValue;
        }
            for (let option of variants[index]?.options || []) {
            const matched = variants[index]?.values?.find(
                (x: any) => x?.name?.toLowerCase?.() === option?.label?.toLowerCase?.()
            );
            option.isDisabled = !!matched;
            }

        setProductData((prevProductData: any) => ({
            ...prevProductData,
            variants
        }));
        setSubProducts();
        generateKey();
    }

    const handleNewOption = (inputValue: string, index: number, loopVarIndex: number) => {
        const currentVariant = productData.variants[index];
        const isExistingOption = currentVariant.options.some((option: any) => option.value === inputValue);
        if (!isExistingOption) {
            const newOption = { label: inputValue, value: inputValue };
            const updatedOptions = [...currentVariant.options, newOption];
            setProductData((prevProductData: any) => {
                let variants = [...prevProductData.variants];
                variants[index].options = updatedOptions;
                return {
                    ...prevProductData,
                    variants
                };
            });
            onVariantSelect(index, loopVarIndex, newOption);
        }
    };



    const onVariantMediaUpload = (index: number, valueIndex: number, images: Media | Media[]) => {
        setProductData((prevProductData: any) => {
            if (valueIndex === -1) {
                return prevProductData; // No update needed
            }

            return {
                ...prevProductData,
                variants: prevProductData.variants.map((variant: any, variantIndex: any) =>
                    variantIndex === index
                        ? {
                            ...variant,
                            values: variant.values.map((value: any, valIndex: any) =>
                                valIndex === valueIndex
                                    ? { ...value, images }
                                    : value
                            ),
                        }
                        : variant
                ),
            };
        });
    };

    const removeVariant = (index: number, valueIndex: number) => {
        let variants = [...productData.variants]
        const removedValue = variants[index].values[valueIndex];

        const options = variants[index].options || [];
        const optionIndex = options.findIndex(
            (option: any) => option.label === removedValue.name
        );
        if (optionIndex !== -1) {
            options[optionIndex].isDisabled = false;
        }

        variants[index].options = options;
        variants[index].values.splice(valueIndex, 1);

        setProductData((prevProductData: any) => ({
            ...prevProductData,
            variants
        }));
        setSubProducts();
    };


    const createVariantForSubProduct = (variant: any, variantValue: any) => {
        return new SubVariants(
            variant.type,
            variant.subType,
            new VariantValuesDTO(variantValue.name),
        );
    }

    const generateSubProducts = (prodData: any, firstVariant: any) => {
        // If only one variant, just return subproducts for its values
        if (!prodData.variants || prodData.variants.length <= 1) {
            return firstVariant.values.map((variant: any) => createSubProductTemplate(firstVariant, variant));
        }

        // For multiple variants, generate all combinations (cartesian product)
        const variantLists = prodData.variants
            .filter((v: any) => v.values && v.values.length)
            .map((v: any) => ({ type: v.type, values: v.values }));

        // Helper to compute cartesian product of variant values
        function cartesian(arr: any[][]): any[][] {
            return arr.reduce(
                (a, b) => a.flatMap(d => b.map(e => [...d, e])),
                [[]]
            );
        }

        // Each element in variantLists is { type, values: [VariantValuesDTO, ...] }
        const valueArrays = variantLists.map((v:any) => v.values);

        const combinations = cartesian(valueArrays);

        // For each combination, build a SubProduct with all variants
        return combinations.map((combination: any[]) => {
            // The first variant is always used for id, the second for secondaryId (if exists)
            const id = combination[0]?.name ?? '';
            const secondaryId = combination.map(x=> x.name).join('_');

            // Build SubVariants for all variants in the combination
            const subVariants = combination.map((variantValue, idx) =>
                createVariantForSubProduct(prodData.variants[idx], variantValue)
            );

            return new SubProduct(
                new PackageDTO(productData["Switch to enter different package dimensions & weight for variations"]),
                id,
                secondaryId,
                subVariants
            );
        });
    }

    const createSubProductTemplate = (variant: any, variantValue: any) => {
        return new SubProduct(
            new PackageDTO(productData["Switch to enter different package dimensions & weight for variations"]),
            variantValue.name,
            variantValue.name,
            [createVariantForSubProduct(variant, variantValue)],
        );
    }




const createDefaultSubProduct = () => {
        return new SubProduct(
            new PackageDTO(productData["Switch to enter different package dimensions & weight for variations"]),
        );
    }

    const syncExistingSubProducts = (tempSubProducts: any[], existingSubProducts: any[]) => {
        let arr = [];
        for (let subProduct of tempSubProducts) {
            const index = existingSubProducts.findIndex(
                (tempSubProduct: any) =>
                    tempSubProduct.secondaryId === subProduct.secondaryId ||
                    tempSubProduct.referenceId && subProduct.referenceId
            );
            if (index !== -1) {
                let matchedSubProduct = existingSubProducts[index];
                arr.push(SubProduct.copy(subProduct, matchedSubProduct))
            } else {
                arr.push(subProduct);
            }
        }
        return arr;
    }

    const setSubProducts = () => {
        let subProducts = [...(productData.subProducts ?? [])];
        let packageBySku = productData.packageBySku ? true : false;
        const firstVariant = productData.variants?.find((variant: any) => variant.values?.length);

        if (!firstVariant) {
            if (!subProducts.length) {
            subProducts = [createDefaultSubProduct()];
        }
        } else {
            const emptyVariantIndex = subProducts.findIndex((subProduct: any) => !subProduct.variants.length);
            if (emptyVariantIndex !== -1) {
                subProducts.splice(emptyVariantIndex, 1);
            }
            let tempSubProducts = generateSubProducts(productData, firstVariant);
            subProducts = syncExistingSubProducts(tempSubProducts, subProducts);
            if (subProducts.length === 1) {
                packageBySku = false;
            }
        }
        setProductData((prevProductData: any) => ({
            ...prevProductData,
            subProducts,
            packageBySku,
        }));
    }

          useEffect(() => {
            const getObj = localStorage.getItem(StorageKeys.productFormData);
        if (getObj) {
            const savedData: any = JSON.parse(getObj);
            if (savedData?.idPath?.length && brands.length === 0) {
              dispatch(getBrandCategoryIdByThunk({ categoryId: savedData?.idPath[0] }));
            }
        }
  }, [ brands.length, dispatch]);



    useEffect(() => {
        console.log(productData, "product data")
        const getObj = localStorage.getItem(StorageKeys.productFormData);
        if (getObj) {
            const savedData: any = JSON.parse(getObj);
            if (!productId && !draftId && (savedData.categoryId != "" || savedData.nameEn != "")) {
                setShowModal(true);
                return;
            }
        }

        // if (productData?.variants?.length) {
        //     let updatedVariants = [...productData.variants];
        //     let alreadySet = false;

        //     updatedVariants = updatedVariants.map((variant) => {
        //         if (!alreadySet && variant.allowImages) {
        //             alreadySet = true;
        //             return variant;
        //         }
        //         return { ...variant, allowImages: false };
        //     });

        //     setProductData((prev: any) => ({
        //         ...prev,
        //         variants: updatedVariants,
        //     }));
        // }

        return () => {
            if (location.pathname === "/draft/add") {
                handleDiscard();
            }
            dispatch(clearForm())
        };

    }, []);


    const renderVariants = (variants: any) => {
        return (
            <div>
                {
                    variants.map((currentVariant: any, index: number) => {
                        const key = `variant${index + 1}`;
                        const isFirstVariant = index === 0 && !customVariantTypeAdded;
                        const hasActualOptions =
                        Array.isArray(currentVariant.options) &&  
                        currentVariant.options.some((opt: any) => opt?.value !== "__add_new__");

                        return (
                            <Card key={key}>
                                <CardHeader>
                                    <h6 className="card-title mb-0">Variant {index + 1} 
                                        {/* <sup className="text-danger fs-6">*</sup> */}
                                        </h6>
                                </CardHeader>
                                <CardBody className="variantsScroll">
                                    <div style={{ marginBottom: '10px' }}>
                                        <p className="text-bold">Variant Name</p>
                                        {editingVariantType ? (
                                            <div style={{ marginTop: 10, width: "220px", display: "flex", marginRight: "20px" }}>
                                                <CreatableSelect
                                                    className="form-control ReactSelect"
                                                    // value={currentVariant.type ? { label: currentVariant.type, value: currentVariant.type } : "variant"}
                                                    onChange={(selected: any) => {
                                                        const newType = selected?.value || "variant";
                                                        setProductData((prev: any) => {
                                                            const updatedVariants = [...prev.variants];
                                                            updatedVariants[index].type = newType;
                                                            return { ...prev, variants: updatedVariants };
                                                        });
                                                        setEditingVariantType(false);
                                                        setCustomVariantTypeAdded(true);
                                                    }}
                                                    onBlur={() => setEditingVariantType(false)}
                                                    isClearable={false} 
                                                    value={
                                                    currentVariant.type
                                                        ? { label: currentVariant.type, value: currentVariant.type }
                                                        : null
                                                }
                                                    placeholder="Enter variant"
                                                    formatCreateLabel={(inputValue) => `➕ Set as "${inputValue}"`}
                                                    options={[]}
                                                    noOptionsMessage={() => null}
                                                // noOptionsMessage={({ inputValue }) =>
                                                //     inputValue ? `Set as "${inputValue}"` : "Type a variant type"
                                                // }
                                                />
                                            </div>
                                        ) : (!currentVariant.fromManual && currentVariant.options?.length) ? (
                                            <p className="fs-14 fw-semibold m-0 ">{currentVariant.type}</p>
                                        ) : (
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <p className="fs-14 fw-semibold m-0 ">{currentVariant.type}</p>
                                                <i
                                                    className="bx bx-edit cursor-pointer"
                                                    onClick={() => setEditingVariantType(true)}
                                                    style={{ fontSize: "18px", marginLeft: "5px" }}
                                                ></i>
                                            </div>
                                        )}
                                    </div>

                                    <p className="text-bold" style={{ marginTop: "10px" }}>Total Variants</p>

                                    <div 
                                        className={`form-check notification-check ${selectedIndex !== null && selectedIndex !== index ? 'cursor-not-allowed' : ''}`}
                                            style={{ cursor: selectedIndex !== null && selectedIndex !== index ? 'not-allowed' : 'pointer' }}
                                    >
                                        <input
                                            className={`form-check-input ${selectedIndex !== null && selectedIndex !== index ? 'cursor-not-allowed' : ''}`}
                                            data-testing-Id='chackBox-variant'
                                            onChange={(e) => updateProductVariantImageCheck(index, e.target.checked)}
                                            disabled={
                                                selectedIndex !== null && selectedIndex !== index
                                            }
                                            type="checkbox"
                                            checked={currentVariant.allowImages}
                                            id={key}
                                        />
                                        <label className="form-check-label" htmlFor={key}>
                                            Add Images <span className="text-muted">Max 8 Images for each variant</span>
                                        </label>
                                    </div>

                                    <ListGroup>
                                        {currentVariant.values.map((loopVar: any, loopVarIndex: number) => (
                                            <ListGroupItem key={`variant-value-${loopVarIndex}`}>
                                                <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                                    <div style={{ flex: "0 0 200px" }} data-testing-Id={`addproduct-variant-select${currentVariant.type}-${loopVar.name}`}>
                                                        {editingVariantType && isFirstVariant && (
                                                            <CreatableSelect
                                                                className="form-control ReactSelect"
                                                                value={currentVariant.type ? { label: currentVariant.type, value: currentVariant.type } : null}
                                                                onChange={(selected: any) => {
                                                                    const newType = selected?.value || "";
                                                                    setProductData((prev: any) => {
                                                                        const updatedVariants = [...prev.variants];
                                                                        updatedVariants[index].type = newType;
                                                                        return { ...prev, variants: updatedVariants };
                                                                    });
                                                                    setCustomVariantTypeAdded(true);
                                                                    generateKey();
                                                                    
                                                                }}
                                                                options={[]}
                                                                isClearable={false} 
                                                                placeholder="Enter variants"
                                                                onInputChange={(inputValue) => {
                                                                    setCustomInputs((prev) => ({ ...prev, [`type-${index}`]: inputValue }));
                                                                }}
                                                                formatCreateLabel={(inputValue) => `➕ Set as "${inputValue}"`}
                                                                noOptionsMessage={({ inputValue }) =>
                                                                    inputValue ? `Set as "${inputValue}"` : "Type a variant type"
                                                                }
                                                            />
                                                        )}

                                                        <CreatableSelect
                                                            className="form-control ReactSelect"
                                                            value={loopVar.name ? { label: loopVar.name, value: loopVar.name } : null}
                                                            onChange={(selected: any) => {
                                                                const newValue = selected?.value;

                                                                const alreadyExists = currentVariant.values.some(
                                                                    (v: any) => (v?.name || '').toLowerCase() === (newValue || '').toLowerCase()
                                                                );

                                                                if (alreadyExists) {
                                                                    setShowModalColor({ isVisible: true, color: false });
                                                                    setErrorMessageColor(`"${newValue}" is already added in this variant.`)
                                                                    setTimeout(() => {
                                                                        setShowModalColor({ isVisible: false, color: false });
                                                                    }, 2000);
                                                                    // toast.warning(`"${newValue}" is already added in this variant.`, {
                                                                    //     autoClose: 1000, // 1 second
                                                                    // });
                                                                    return;
                                                                }


                                                                onVariantSelect(index, loopVarIndex, selected);
                                                                setCustomInputs((prev) => ({ ...prev, [index]: "" }));
                                                            }}

                                                            options={Array.isArray(currentVariant.options)
                                                                ? currentVariant.options.map((opt: any) =>
                                                                    typeof opt === "string" ? { label: opt, value: opt } : opt
                                                                )
                                                                : []}
                                                            isClearable={false} 
                                                            placeholder="Type Here..."
                                                            onInputChange={(inputValue) => {
                                                                setCustomInputs((prev) => ({ ...prev, [index]: inputValue }));
                                                            }}
                                                            formatCreateLabel={(inputValue) => `➕ Create "${inputValue}"`}
                                                            noOptionsMessage={({ inputValue }) =>
                                                                inputValue ? `Create "${inputValue}"` : "Type to search or create"
                                                            }
                                                        />
                                                    </div>

                                                    {currentVariant.allowImages && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: 'pointer' }}>
                                                            <MediaUploader
                                                                onMediaUpdate={(value) => onVariantMediaUpload(index, loopVarIndex, value)}
                                                                isMultiple={true}
                                                                smallUploader={true}
                                                                initialMedia={loopVar.images}
                                                                dataTestingId={`variantMedia-addProduct${loopVarIndex}`}
                                                                threeDotIcon={true}
                                                            />
                                                        </div>
                                                    )}

                                                    <i
                                                        className="bx bx-trash bg-red text-white rounded bg-danger p-1 cursor-pointer"
                                                        style={{ marginLeft: "auto" }}
                                                        data-testing-Id={`addproduct-variant-remove${currentVariant.type}-${loopVar.name}`}
                                                        onClick={() => removeVariant(index, loopVarIndex)}
                                                    />
                                                </div>
                                            </ListGroupItem>
                                        ))}
                                {(currentVariant.values.length === 0 || currentVariant.values[currentVariant.values.length - 1].name) && (
                                        <ListGroupItem style={{ borderStyle: "dashed" }}>
                                            <div className="d-flex align-items-center" style={{ gap: 10 }}>
                                            <div style={{ flex: "0 0 200px" }} data-testing-Id={`addproduct-variant-select${currentVariant.type}`}>
                                                {hasActualOptions ? (
                                                <Select
                                                    className="form-control ReactSelect"
                                                    value={null}
                                                    onChange={(selected: any) => onVariantSelect(index, -1, selected)}
                                                    options={[
                                                    ...currentVariant.options.filter(
                                                    (o: any) => o?.value !== "__add_new__"
                                                    ),
                                                    ...currentVariant.options.filter(
                                                    (o: any) => o?.value === "__add_new__"
                                                    ),
                                                  ]}
                                                />
                                                ) : (
                                                <CreatableSelect
                                                    className="form-control ReactSelect"
                                                    value={null}
                                                    onChange={(selected: any) => onVariantSelect(index, -1, selected)}
                                                    options={[]}
                                                    isClearable={false} 
                                                    placeholder="Type Here..."
                                                    formatCreateLabel={(inputValue) => `➕ Create "${inputValue}"`}
                                                    noOptionsMessage={({ inputValue }) =>
                                                    inputValue ? `Create "${inputValue}"` : "Type to create"
                                                    }
                                                />
                                                )}
                                            </div>
                                            </div>
                                        </ListGroupItem>
                                        )}

                                        
                                    </ListGroup>
                                </CardBody>
                            </Card>
                        );
                    })}
            </div>
        );
    };

    useEffect(() => {
        console.log(productData)
    }, [productData])

    const renderFormField = (category: any, parentForm: any = undefined, bindingProperty: any = productData, bindingFunc = (key: string, value: any) => updateProductData(key, value), bindKeyIndex: number = -1) => {
        const bindingKey = getKeyForFormField(category, parentForm, bindKeyIndex);
        if (
            category.uiType === "CustomEditor" ||
            category.uiType === "RichText" ||
            category.uiType === "richText" ||
            category.uiType === "ListEditor"
        ) {
            let config = {
                toolbar: ['bulletedList']
            };
            if (category.uiType === "CustomEditor") {
                config = {
                    toolbar: [
                        'fontSize',
                        'alignment:left',
                        'alignment:center',
                        'alignment:right',
                        'alignment:justify',
                        'bulletedList',
                        'numberedList',
                        'imageUpload',
                    ],
                };
            } else if (category.uiType === "RichText") {
                config = {
                    toolbar: [
                        'fontSize',
                        'alignment:left',
                        'alignment:center',
                        'alignment:right',
                        'alignment:justify',
                        'bulletedList',
                        'numberedList',
                        'imageUpload',
                        'fullScreen'
                    ],
                };
            } else if (category.label === "Size Chart") {
                if (bindingProperty["Product Attributes"]?.["Size Chart"]) {
                    bindingProperty["Product Attributes.Size Chart"] = bindingProperty["Product Attributes"]["Size Chart"];
                }
                config = {
                    toolbar: ['bulletedList', 'imageUpload']
                };
            }
            if (!bindingProperty[bindingKey]) {
                bindingProperty[bindingKey] = "";
            }

            return (
                <>
                    <div
                        data-testing-Id={'addproduct-' + category.name}
                    >

                        <input
                            type="text"
                            required={category.required}
                            value={resolveFieldValue(bindingProperty, bindingKey)}
                            name={bindingKey}
                            className="form-control"
                            style={{ position: 'absolute', opacity: 0, height: 0, width: 0, zIndex: -1 }}
                            onChange={() => { }}
                        />

                        <CKEditor
                            editor={ClassicEditor}
                            data={bindingProperty[bindingKey]}
                            config={{
                                ...config,
                                placeholder: category.placeholder ?? "Please Input",
                            }}
                            onReady={(editor: any) => {
                                editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
                                    return new MyUploadAdapter(loader);
                                };
                            }}

                            onChange={async (event, editor) => {
                                let data = editor.getData();
                                if (!config.toolbar.includes('imageUpload')) {
                                    data = data.replace(/<img[^>]*>/g, '');
                                }
                                bindingFunc(bindingKey, data);
                            }}
                        />
                    {category.label === "Product Description" &&
                        aiData?.productDescription &&
                        showProductDescriptionOption &&
                        !userDescriptionDecisionMade && (
                            <div className="orderDvYellow">
                                <div className="d-flex justify-content-start align-items-center gap-1">
                                    <img src={star} alt="" />
                                    <h6>
                                        Suggested By Buypass Ai{" "}
                                        <span
                                            className="mdi mdi-information fs-5"
                                            style={{ color: "#97BEEE" }}
                                        ></span>
                                    </h6>
                                </div>
                                <p dangerouslySetInnerHTML={{ __html: aiData.productDescription }}></p>
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => {
                                        bindingFunc(bindingKey, aiData.productDescription); // ✅ CKEditor bind
                                        setUserDescriptionDecisionMade(true);
                                    }}
                                >
                                    Use This Description
                                </button>
                            </div>
                        )}


                        {/* Add remove image functionality */}
                        {/* {bindingProperty[bindingKey] && bindingProperty[bindingKey].includes('<img') && (
                            <button
                                type="button"
                                className="btn btn-danger mt-2"
                                onClick={() => {
                                    const updatedData = bindingProperty[bindingKey].replace(/<img[^>]*>/g, '');
                                    bindingFunc(bindingKey, updatedData);
                                }}
                            >
                                Remove Image
                            </button>
                        )} */}
                    </div>
                    {/* {!bindingProperty[bindingKey].length && category.required && <FormFeedback type="invalid" className='d-block'> {category.label} is Required </FormFeedback>} */}
                </>
            )
        }
        if (
            category.uiType === "marketImages"
        ) {
            return (
                <div className="mb-4" key="product-image-section">
                    <h5 className="fs-14 mb-1">Product Image</h5>
                    <p className="text-muted">Add Product main Image.</p>
                    <div className="mediaUpload-width w-25" key="promotion-image" style={{ cursor: 'pointer' }}>
                        <MediaUploader
                            onMediaUpdate={(value) => bindingFunc("promotionImage", value)}
                            isMultiple={false}
                            initialMedia={bindingProperty.promotionImage}
                            dataTestingId={"buyerImage_addProduct"}
                            threeDotIcon={true}
                        />
                    </div>
                    {/* <p className="text-muted">Add Product main Image (White BG).</p>
                    <div className="mediaUpload-width w-25" key="promotion-white-bg-image">
                        <MediaUploader
                            onMediaUpdate={(value) => bindingFunc("promotionWhiteImageBg", value)}
                            isMultiple={false}
                            initialMedia={bindingProperty.promotionWhiteImageBg}
                            dataTestingId={"productImage_addProduct"}
                            threeDotIcon={true}
                        />
                    </div> */}
                </div>
            );
        }
        if (category.uiType === "MainImage") {
     const error = errors && (errors.productImages);

            return <div className="mediaUpload-width w-25" ref={uploaderRef} style={{ cursor: 'pointer' }}>
                <MediaUploader
                    onMediaUpdate={(value) => bindingFunc("productImages", value)}
                    isMultiple={true}
                    initialMedia={bindingProperty.productImages}
                    dataTestingId={"buyerImageTow_addProduct"}
                    threeDotIcon={true}
                />
                {error && <FormFeedback type="invalid" className='d-block'> {error} </FormFeedback>}
            </div>
        }
        if (
            category.uiType === "input" ||
            category.uiType === "NumberPicker" ||
            (category.uiType === "combobox" && (!category.dataSource || !category.dataSource.length))
        ) {
            const isPrice = category.label.toLowerCase().includes('price');
            if (isPrice) {
                const error = errors && (bindingKey);
                return (
                    <div className="input-group">
                        {isPrice && <span style={{ fontSize: 10, padding: 5 }} className="input-group-text" id="basic-addon1">Rs</span>}
                        <Input
                            type="text" 
                            data-testing-Id={'addproduct-' + category.name}
                            required={category.required}
                            key={currentBindingKey}
                            className="form-control"
                            id="product-title-input"
                            placeholder={category.placeholder ?? category.label}
                            name={bindingKey + bindKeyIndex}
                            value={resolveFieldValue(bindingProperty, bindingKey)}
                            onChange={(e) => {
                                const sanitizedValue = e.target.value.replace(/[^0-9.]/g, ''); 
                                bindingFunc(bindingKey, sanitizedValue);
                            }}
                        />
                        {error && <FormFeedback type="invalid" className='d-block price'> {errors[error + bindKeyIndex]} </FormFeedback>}
                    </div>
                );
            }
            // console.log(errors)
            const error = errors && (bindingKey);

            return <div >

                <Input
                    type={category.uiType === "NumberPicker" ? "number" : "text"}
                    data-testing-Id={'addproduct-' + category.name}
                    className="form-control"
                    id="product-title-input"
                    placeholder={category.placeholder ?? category.label}
                    required={category.required}
                    readOnly={category.readOnly}
                    // key={resolveFieldValue(bindingProperty, bindingKey) as string}
                    key={currentBindingKey}
                    name={bindingKey + bindKeyIndex}
                    value={resolveFieldValue(bindingProperty, bindingKey)}
                    onChange={(e) => bindingFunc(bindingKey, e.target.value)}
                />
                {error && <FormFeedback type="invalid" className='d-block newError'> {errors[error + bindKeyIndex]} </FormFeedback>}
            </div>
        }
        if (
            category.uiType === "translateInput"
        ) {
            return (
                <textarea
                    className={`form-control rounded-top rounded-0 border p-3 ${(!resolveFieldValue(bindingProperty, bindingKey) && category.required) ? "is-invalid" : ""}`}
                    data-testing-Id={'addproduct-' + category.name}
                    style={{ minHeight: "100px" }}
                    rows={5}
                    placeholder={category.placeholder ?? category.label}
                    name={bindingKey}
                    required={category.required}
                    value={resolveFieldValue(bindingProperty, bindingKey)}
                    onChange={(e) => bindingFunc(bindingKey, e.target.value)}
                ></textarea>
            );
        }
        if (category.uiType === "select" ||
            category.uiType === "searchSelect"

        ) {
            return <>
                {category.label !== "Brand" && (
                    <select className={`form-control pe-5 password-input ${!resolveFieldValue(bindingProperty, bindingKey) && "is-invalid"}`}
                        value={resolveFieldValue(bindingProperty, bindingKey)}
                        data-testing-Id={'addproduct-' + category.name}
                        required={category.required}
                        name={category.label}
                        // ref={selectRef}
                        onChange={(e) => bindingFunc(bindingKey, e.target.value)}
                        onBlur={handleScrollToSelect}
                    >
                        <option hidden defaultValue="" >{category.placeholder}</option>
                        {
                            category.dataSource && category.dataSource.map((option: any, index: any) =>
                                <option key={bindingKey + option.value} value={option.text} data-testing-Id={'addproduct-' + index}>{option.text} </option>
                            )
                        }
                    </select>
                )}
                {category.label === "Brand" && (
                    <select
                        className={`form-control pe-5 password-input ${!resolveFieldValue(bindingProperty, bindingKey) && "is-invalid"
                            }`}
                        value={
                            resolveFieldValue(bindingProperty, bindingKey) !== "No Brand"
                                ? resolveFieldValue(bindingProperty, bindingKey) || ""
                                : "No Brand"
                        }
                        data-testing-Id={"addproduct-" + category.name}
                        required={category.required}
                        name={category.label}
                        onChange={(e) => {
                            const selectedValue = e.target.value;

                            if (selectedValue === "addBrand") {
                                window.open("/brand-form", "_blank");
                            } else {
                                bindingFunc(bindingKey, selectedValue);
                            }
                        }}
                        onBlur={handleScrollToSelect}
                    >
                        <option value="" hidden>
                            Select a brand
                        </option>

                        {brands.map((brand: { id: string; name: string }) => (
                            <option key={brand.id} value={brand.name}>
                                {brand.name}
                            </option>
                        ))}

                        <option disabled style={{ fontWeight: "bold", color: "#555" }}>
                            Cannot find brand?
                        </option>

                        <option value="No Brand" className="bg-black text-white">No Brand</option>
                        <option value="addBrand" style={{ background: "#ffbe0b" }} className="text-white">Add New Brand</option>
                    </select>


                )}
            </>


        }
        if (category.uiType === "checkbox" ||
            (category.uiType === "combobox" && category.dataSource && category.dataSource.length)) {
            return <div className="d-flex" style={{ flexWrap: "wrap", gap: 10 }}>
                {category.dataSource && category.dataSource.map((check: any, index: number) => {
                    let checked = resolveFieldValue(bindingProperty, bindingKey);
                    if (checked && (category.multiple || category.uiType === "combobox")) {
                        checked = checked.includes(check.text);
                    }
                    return (
                        <div key={category.name + check.text + index} className="form-check notification-check">
                            <input data-testing-Id={'addproduct-' + category.name + check.name} className="form-check-input"
                                checked={checked}
                                value={check.text}
                                onChange={() => onCheckboxChange(bindingKey, check.text, category.multiple || category.uiType === "combobox")} type="checkbox" id={category.name + check.text + index} />
                            <label className="form-check-label" htmlFor={category.name + check.text + index}>{check.text}</label>
                        </div>
                    )
                })}
            </div>
        }
        if (category.uiType === "RadioGroup") {
            return (
                <div className="d-flex" style={{ flexWrap: "wrap", gap: 10 }}>
                    {category.dataSource?.map((check: any, index: number) => (
                        <div key={`${bindingKey}-${check.text}-${index}`} className="form-check mb-2">
                            <Input
                                data-testing-Id={`addproduct-${category.name}-${check.text}`}
                                className="form-check-input"
                                checked={bindingProperty[bindingKey] === check.text}
                                value={check.text}
                                onChange={(e) => bindingFunc(bindingKey, e.target.value)}
                                type="radio"
                                name={bindingKey}
                                id={`${bindingKey}-${check.text}-${index}`}
                            />
                            <Label className="form-check-label" htmlFor={`${bindingKey}-${check.text}-${index}`}>
                                {check.text}
                            </Label>
                        </div>
                    ))}
                </div>
            )
        }
        if (category.uiType === "Switch") {
            let isDisabled = false;
            if (category.name === "packageBySku") {
                if (bindingProperty && bindingProperty.subProducts && bindingProperty.subProducts) {
                    isDisabled = bindingProperty.subProducts.length === 1;
                }
            }
            return (
                <div className="d-flex" style={{ flexWrap: "wrap", gap: 10 }}>
                    <div className="form-check form-switch form-switch-lg" dir="ltr">
                        <Input data-testing-Id={'addproduct' + -category.name} disabled={isDisabled} type="checkbox" onChange={(e) => onCheckboxChange(category.name, e.target.checked, false)} className="form-check-input" id={category.name} />
                        <Label className="form-check-label" htmlFor={category.name}>{category.info.right}</Label>
                    </div>
                </div>
            )
        }
        if (category.uiType === "PackageWeight") {
            return renderPackageWeightField(
                bindingProperty,
                'packageWeight',
                'packageWeightUnit',
                (key: string, value: any) => bindingFunc(key, value),
                (key: string, value: any) => bindingFunc(key, value),
            );
        }

        // if (category.uiType === "PackageVolume") {
        //     return renderPackageDimensionField(
        //         bindingProperty,
        //         "packageLength",
        //         "packageWidth",
        //         "packageHeight",
        //         (key: string, value: any) => bindingFunc(key, value)
        //     );
        // }
        if (category.uiType === "SkuTableV2") {
            // const error = errors && (category.sequence);
            return <div>
                {bindingProperty.variants && renderVariants(bindingProperty.variants)}
                {renderProductTable(category)}
                {/* {error && <FormFeedback type="invalid" className='d-block'> {error} </FormFeedback>} */}
            </div>

        }
        if (category.name === "newVideo") {
            return <div className="mediaUpload-width w-100">
                <VideoUploader
                    onMediaUpdate={(value) => bindingFunc("productVideo", value)}
                    initialMedia={bindingProperty.productVideo}
                    detaIdProps={"video_uploader"}
                />
            </div>
        }
        if (category.uiType === "toggle") {
            return (
                <div className="form-check form-switch d-flex justify-content-center" >
                    <Input className="form-check-input toggleDV" type="checkbox" checked={bindingProperty[bindingKey]} role="switch" onChange={(e) => bindingFunc(bindingKey, e.target.checked)} data-testing-id="availabilityToggle_EcommerceProductsIndex" />
                </div>
            );
        }
        if (category.uiType === "SpecialPrice") {
            return <SpecialPriceSelector
                specialPrice={bindingProperty[bindingKey]}
                onSpecialPriceChange={(val) => bindingFunc(bindingKey, val)}
            />
        }
        return <div>{category.uiType} ({category.name})</div>
    }

    const renderPackageDimensionField = (bindingProperty: any, packageLengthKey: string, packageWidthKey: string, packageHeightKey: string, onValueUpdate: any) => {
        if (!dimension) {
            return <div></div>
        }
        return (
            <div className="d-flex align-items-center pt-3" style={{ gap: 5 }}>
                <Input
                    type="number"
                    data-testing-Id={'addproduct-' + packageLengthKey}
                    className={`form-control ${!bindingProperty[packageLengthKey] || bindingProperty[packageLengthKey] < dimension.minimum || bindingProperty[packageLengthKey] > dimension.maximum ? "is-invalid" : ""}`}
                    min={dimension.minimum}
                    max={dimension.maximum}
                    required={dimension.required}
                    placeholder={`${dimension.minimum} ~ ${dimension.maximum}`}
                    name={dimension.name}
                    value={bindingProperty[packageLengthKey]}
                    onChange={(e) => onValueUpdate(packageLengthKey, e.target.value)}
                />
                x
                <Input
                    type="number"
                    className={`form-control ${!bindingProperty[packageWidthKey] || bindingProperty[packageWidthKey] < dimension.minimum || bindingProperty[packageWidthKey] > dimension.maximum ? "is-invalid" : ""}`}
                    data-testing-Id={'addproduct-' + packageWidthKey}
                    min={dimension.minimum}
                    max={dimension.maximum}
                    placeholder={`${dimension.minimum} ~ ${dimension.maximum}`}
                    required={dimension.required}
                    name={dimension.name}
                    value={bindingProperty[packageWidthKey]}
                    onChange={(e) => onValueUpdate(packageWidthKey, e.target.value)}
                />
                x
                <Input
                    type="number"
                    className={`form-control ${!bindingProperty[packageHeightKey] || bindingProperty[packageHeightKey] < dimension.minimum || bindingProperty[packageHeightKey] > dimension.maximum ? "is-invalid" : ""}`}
                    data-testing-Id={'addproduct-' + packageHeightKey}
                    min={dimension.minimum}
                    max={dimension.maximum}
                    required={dimension.required}
                    placeholder={`${dimension.minimum} ~ ${dimension.maximum}`}
                    name={dimension.name}
                    value={bindingProperty[packageHeightKey]}
                    onChange={(e) => onValueUpdate(packageHeightKey, e.target.value)}
                />

            </div>
        );
    }

    const renderPackageWeightField = (bindingProperty: any, key: string, unitKey: string, onChangeInput: (key: string, value: any) => void, onSelectChange: (key: string, value: any) => void
    ) => {
        if (!weightage) return <div></div>
        const unitMapping: Record<string, string> = {
        g: "gr",
        gr: "g",
        };

        const error = errors && (errors[key] || errors[unitKey]);
        const selectedUnit = bindingProperty[unitKey] || "kg";

        const min = selectedUnit === "gr" ? 1 : 0.001;
        const max = selectedUnit === "gr" ? 300000 : 300;
        const placeholder = `${min} ~ ${max}`;

        const value = parseFloat(bindingProperty[key]);
        const isInvalid =
            selectedUnit &&
            (!value || value < min || value > max);

        return (
            <>
            <div className="d-flex align-items-stretch gap-2">
                <Input
                    key={selectedUnit}
                    style={{ paddingLeft: 8, paddingRight: 8 }}
                    type="number"
                    data-testing-Id={'addproduct-' + key}
                    className={`form-control pe-5 password-input ${isInvalid ? "is-invalid" : ""}`}
                    required={weightage.required}
                    id="product-title-input"
                    min={min}
                    max={max}
                    step={selectedUnit === "gr" ? 1 : 0.001}
                    placeholder={placeholder}
                    name={key}
                    value={bindingProperty[key]}
                    onChange={(e) => onChangeInput(key, e.target.value)}
                />

                <div style={{ flex: "0 0 145px" }}>
                    <select className={`form-select pe-5 password-input ${error?.unitKey ? "is-invalid" : ""}`}
                        value={bindingProperty[unitKey] || "kg"}
                        required
                        name={unitKey}
                        data-testing-Id={'addproduct-' + unitKey}
                        onChange={(event) => {
                            onSelectChange(unitKey, event.target.value);
                            onChangeInput(key, '');
                        }}
                    >
                        <option hidden value="">Select Unit</option>
                        {/* {weightage.units.map((option: any, index: number) => (
                            <option
                                key={unitKey + option.value}
                                value={option.value}
                                data-testing-Id={'addproduct-' + option.value + index}
                            >
                                {option.value}
                            </option>
                        ))} */}
                        {weightage.units
                            .filter((option: any) => option.value === "kg")
                            .map((option: any, index: number) => (
                            <option
                                key={unitKey + option.value}
                                value={option.value}
                                data-testing-Id={'addproduct-' + option.value + index}
                            >
                                {option.value}
                            </option>
                            ))
                        }
                    </select>

                    {error && (
                        <FormFeedback type="invalid" className="d-block">
                            {error}
                        </FormFeedback>
                    )}
                </div>
            </div>
          {(aiData?.productWeight || aiData?.weight) && showWeightOption && !userWeightDecisionMade && (
               <div className=" orderDvYellow">
    <div className=" d-flex justify-content-start align-items-center gap-1">
        <img src={star} alt="" />
    <h6>Suggested By Buypass Ai  <span className="mdi mdi-information fs-5" style={{ color: "#97BEEE" }}></span></h6>
    </div>
    <p >{aiData.productWeight || aiData.weight} {aiData.weightUnit}</p>
    <button
      className="btn btn-outline-secondary"
       onClick={() => {
        // setUserWeightDecisionMade(true); 
        const fullValue = aiData.productWeight || aiData.weight;
        const numericValue = parseFloat(fullValue);
        const aiUnit = aiData.weightUnit;
        const mappedUnit = unitMapping[aiUnit] || aiUnit;

        if (!isNaN(numericValue) && mappedUnit) {
            onChangeInput(key, numericValue);
        onSelectChange(unitKey, mappedUnit);
        }
    setUserWeightDecisionMade(true);
      }}
    >
      Use This Weight
    </button>
  </div>
//   <div className="mb-2">
//     <h6 className="mb-2 fw-bold">
//       AI Suggested Weight: {aiData.productWeight || aiData.weight}
//     </h6>
//     <button
//       className="btn btn-success btn-sm me-2"
//       onClick={() => {
//         const weightValue = aiData.productWeight || aiData.weight;
//         onChangeInput(key, weightValue); // ✅ Bind to input
//         setUserWeightDecisionMade(true);
//       }}
//     >
//       ✅ Yes
//     </button>
//     <button
//       className="btn btn-danger btn-sm"
//       onClick={() => {
//         setUserWeightDecisionMade(true); // ❌ Just hide suggestion
//       }}
//     >
//       ❌ No
//     </button>
//   </div>
)}

            </>

        
        );
    };


    const updateSubProductData = (subcategoryIndex: number, category: any, key: string, value: any) => {
        let subproducts = [...productData.subProducts];
        let subProduct = subproducts[subcategoryIndex];
        if (subProduct) {
            if (category.isExtra) {
                subProduct.extra[key] = value;
            } else {
                subProduct[key] = value;
            }
            setProductData((prevProductData: any) => ({
                ...prevProductData,
                subproducts
            }));
        }
    }

    const renderProductTable = (category: any) => {
        if (!productData.categoryId) {
            return;
        }
        let categoryKeys: any[] = [];
        const originalKeys = [
            "price",
            "SellerSku",
            "quantity",
            "seller_promotion",
        ];
        const requiredKeys = [
            "price",
            "quantity",
            "seller_promotion",
        ];

        for (let attr of category.sequence) {
            const attribute = { ...category.attributes[attr], required: requiredKeys.includes(attr), isExtra: !originalKeys.includes(attr) };
            if (!attribute || attribute.uiType === 'hidden' || attribute.visible === false) {
                continue;
            }
            categoryKeys.push(attribute);
        }

        if (productId && !category.sequence.includes("sku")) {
        categoryKeys.unshift({
            name: "sku",
            label: "sku",
            uiType: "input",
            required: true,
            isExtra: false,
            readOnly: true,
            width: 150,
        });
        }

        categoryKeys.push(SubProductAvailability);
        if (productData.packageBySku) {
            categoryKeys.splice(2, 0, { ...category.attributes.packageDimensions, width: 320 });
            categoryKeys.splice(2, 0, { ...category.attributes.packageWeight, width: 200 });
        }
        let variants: any[] = [];
        if (productData.variants) {
            for (let i = 0; i < productData.variants.length; i++) {
                const variant = productData.variants[i];
                if (variant.values.length) {
                    variants.push({ label: variant.type, key: i === 0 ? "id" : "secondaryId" });
                }
            }
        }
        return (
            <Card>
                <CardHeader>

                    <h6 className="card-title mb-0">{category.label} <sup className="text-danger fs-6">*</sup></h6>
                </CardHeader>
                <CardBody>
                    <div className="table-responsive table-card">
                        <Table striped={true} style={{ tableLayout: "fixed", }} className="align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    {
                                        variants.map((variant: any) => {
                                            return (
                                                <th key={variant.key} scope="col" style={{ background: "#f3f6f9", width: 120, textAlign: "center" }}>{variant.label}</th>
                                            );
                                        })
                                    }
                                    {
                                        categoryKeys.map((field: any) => {
                                              if (field.name === 'seller_promotion' || field.label === 'Free Items') return null; 
                                            return (

                                                <th scope="col" style={{ background: "#f3f6f9", width: field.width ?? 120, textAlign: "center" }} className={field.sticky ? 'colSticky' : ''}>{field.label} {field.required && <sup style={{ color: 'red' }}>*</sup>}
                                                    {
                                                        field.help && <span>
                                                            <button type="button" style={{ background: "none", border: "none" }} id={'info-' + field.label}><span className="mdi mdi-information" ></span></button>
                                                            <UncontrolledTooltip
                                                                placement="top"
                                                                target={'info-' + field.label}
                                                            > {field.help} </UncontrolledTooltip>
                                                        </span>
                                                    }

                                                </th>
                                            );
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    productData.subProducts && productData.subProducts.map((subProduct: any, subcategoryIndex: number) => {
                                        const style: any = { background: "#f3f6f9", textAlign: "center" };
                                        const inputStyle = { paddingLeft: 8, paddingRight: 8 }
                                        return (
                                            <tr>
                                                {
                                                    variants.map((variant: any, variantIdx: number) => {
                                                        return (
                                                            <td style={style} key={variant.key + '-' + variantIdx} scope="col">{typeof subProduct?.secondaryId === 'string' ? subProduct.secondaryId.split('_')[variantIdx] : ''}</td>
                                                        );
                                                    })
                                                }
                                                {
                                                    categoryKeys.map((field: any, fieldIdx: number) => {
                                                        if (field.name === 'seller_promotion' || field.label === 'Free Items') return null;
                                                        const className = field.sticky ? 'colSticky' : '';
                                                        // const error = errors && (field.name );
                                                        return (
                                                            <td key={(field.key || field.name || field.label) + '-' + fieldIdx} style={style} scope="col" className={className}>
                                                                {renderFormField(field, subcategoryIndex, field.isExtra ? subProduct.extra : subProduct, (key, value) => updateSubProductData(subcategoryIndex, field, key, value))}
                                                                {/* {error && <FormFeedback type="invalid" className='d-block'> {error} </FormFeedback>} */}
                                                            </td>
                                                        );
                                                    })
                                                }
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card >
        );
    }

    const setNestedProductData = (key: string, value: any) => {
        setProductData((prevProductData: any) => {
            const keys = key.split('.');
            const lastKey = keys.pop()!;
            const updateNestedObject = (obj: any, keys: string[], value: any): any => {
                if (keys.length === 0) {
                    return value;
                }
                const [currentKey, ...remainingKeys] = keys;
                return {
                    ...obj,
                    [currentKey]: updateNestedObject(
                        obj[currentKey] || {},
                        remainingKeys,
                        value
                    ),
                };
            };

            return updateNestedObject(prevProductData, [...keys, lastKey], value);
        });
    };

    const updateProductData = (key: string, value: any) => {
        if (key.includes('.')) {
            setNestedProductData(key, value);
        } else {
            setProductData((prevProductData: any) => ({
                ...prevProductData,
                [key]: value,
            }));
        }
    }

    const renderTooltip = (category: any) => {
        if (!category.info) {
            return;
        }
        return (
            <span>
                <button type="button" style={{ background: "none", border: "none", paddingTop: "0px", paddingBottom: "0px" }} id={'info-' + category.name}><span className="mdi mdi-information fs-5" style={{ color: "#97BEEE" }}></span></button>


                {category.info && category.info.help && !category.info.top && (
                    <UncontrolledTooltip placement="top" target={'info-' + category.name}
                        dangerouslySetInnerHTML={{ __html: category.info.help }}
                    >
                    </UncontrolledTooltip>
                )}

                {category.info && category.info.top && (
                    <UncontrolledTooltip
                        placement="top"
                        target={'info-' + category.name}
                        dangerouslySetInnerHTML={{ __html: category.info.top }}
                    />
                )}
            </span>
        )
    }

    const hasAdditionalData = (form: any) => {
        return Array.isArray(form.dataSource) && form.dataSource.length > 2;
    };


    const toggleShowMore = (formName: string) => {
        let list = [...importantFieldsShown];
        if (list.includes(formName)) {
            list.splice(list.indexOf(formName), 1);
        } else {
            list.push(formName);
        }
        setImportantFieldsShown(list);
    };

    const renderSizeChartUI = (form: any) => {
        const error = errors && (errors[form.label] || errors[form.name]);
        return (
            <div key={form.label} className="mb-3">
                <Card>
                    <CardHeader>
                        <Label className="form-label" htmlFor="product-title-input">
                            {form.label}{form.required && <sup className="text-danger fs-6">*</sup>}
                            {renderTooltip(form)}
                        </Label>
                        {error && <FormFeedback type="invalid" className='d-block'> {error} </FormFeedback>}
                    </CardHeader>
                    <CardBody>
                        <div className="mb-3" style={{ cursor: 'pointer' }}>
                            <MediaUploader
                                onMediaUpdate={(value) => updateProductData("sizeChartImage", value)}
                                isMultiple={false}
                                initialMedia={productData.sizeChartImage}
                                threeDotIcon={true}
                            />
                        </div>
                    </CardBody>
                </Card>
            </div>
        );
    }

    const renderFormGroup = (index: number, form: any, parentForm: any = undefined) => {
        const fieldsToExcludeForLoop = [
            "select",
            "checkbox",
            "RadioGroup",
            "combobox",
        ];
        const groupToExcludeForLoop = [
            "newVideo",
        ];
        if (form.uiType === 'SalesSizeChartTool') {
            return renderSizeChartUI(form);
        }
        if (!groupToExcludeForLoop.includes(form.name) && !fieldsToExcludeForLoop.includes(form.uiType) && form.dataSource && form.dataSource.length) {
            return <div key={form.label} className="mb-3">
                <Card>
                    <CardHeader>
                        <Label className="form-label" htmlFor="product-title-input">
                            {form.label}{form.required && <sup className="text-danger fs-6">*</sup>}
                            {renderTooltip(form)}
                        </Label>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            {
                        (() => {
                    const showAll = importantFieldsShown.includes(form.name);
                    const requiredFields = form.dataSource.filter((f: any) => f.required);
                    const optionalFields = form.dataSource.filter((f: any) => !f.required);

                    let fieldsToRender: any[] = [];

                    if (showAll) {
                        fieldsToRender = [...requiredFields, ...optionalFields];
                    } else {
                        fieldsToRender = [...requiredFields];
                        if (requiredFields.length < 2) {
                        const remaining = 2 - requiredFields.length;
                        fieldsToRender = [
                            ...requiredFields,
                            ...optionalFields.slice(0, remaining),
                        ];
                        }
                    }
                    return fieldsToRender.map((dataSource: any, index: number) => (
                        <Col lg={6} key={dataSource.name}>
                        {renderFormGroup(index, dataSource, form)}
                        </Col>
                    ));
                    })()
                            }
                        </Row>
                               {/* <Row>
                            {
                                [...form.dataSource].sort((a: any, b: any) => b.important - a.important).map((dataSource: any, index: number) => {
                                    let showAll = importantFieldsShown.includes(form.name);
                                    let isAllowed = showAll || index < 2;

                                    if (isAllowed) {
                                        return (<Col lg={6} key={dataSource.name}> {renderFormGroup(index, dataSource, form)}</Col>);
                                    } else {
                                        return <span key={dataSource.name} style={{ display: "none" }}></span>
                                    }
                                })
                            }
                        </Row> */}
                    </CardBody>
                    <CardFooter>
                        {hasAdditionalData(form) && (
                            <Button color="secondary" data-testing-Id="showMore_button" outline onClick={() => toggleShowMore(form.name)} > Show {importantFieldsShown.includes(form.name) ? "Less" : "More"} </Button>
                        )}
                    </CardFooter>
                </Card>
            </div>
        }
        let nonLabelClass = "";
        if (
            form.uiType === "RadioGroup" ||
            form.uiType === "Switch" ||
            form.uiType === "checkbox" ||
            form.uiType === "combobox" ||
            form.uiType === "CustomEditor" ||
            form.uiType === "RichText" ||
            form.uiType === "richText" ||
            form.uiType === "ListEditor" ||
            form.uiType === "marketImages"
        ) {
            nonLabelClass = "app-label";
        }
        if (parentForm) {
            const error = errors && (errors[form.label] || errors[form.name]);
            return (
                <div id={form.label || form.name} key={form.name} className={"formContainer  " + nonLabelClass}>
                    <Label className="form-label" htmlFor="product-title-input">
                        {form.label}{form.required && <sup className="text-danger fs-6">*</sup>}
                    </Label>
                    {renderFormField(form, parentForm)}
                    {error && <FormFeedback type="invalid" className='d-block'> {error} </FormFeedback>}
                </div>
            )

        } else if (skipLabels.includes(form.label)) {
            return <></>;
        } else {
            const error = errors && (errors[form.label] || errors[form.name]);
            return (
                <>
                    {
                        form.label?.trim() !== "Switch to enter different package dimensions & weight for variations" && (
                            <Card>
                                <CardBody>
                                    {form && (
                                        <>
                                            <div key={form.name} className={"formContainer  " + nonLabelClass}>
                                                <Label className="form-label" htmlFor="product-title-input">
                                                    {form.label === "Price & Stock" ? "color variants" : form.label}{form.required
                                                    // <sup className="text-danger fs-6">*</sup>
                                                    }
                                                    {renderTooltip(form)}
                                                </Label>
                                                {renderFormField(form)}
                                                {error && <FormFeedback type="invalid" className='d-block'> {error} </FormFeedback>}
                                            </div>
                                        </>
                                    )}
                                </CardBody>

                            </Card>
                        )
                    }

                </>
            )
        }
    }

    const renderForm = (forms: any[]) => {
        if (!forms || !forms.length || !productData.categoryId) {
            return <div></div>
        }
        const categoriesToExcludes: string[] = [
            "categoryPath",
            "title",
            "termsConditions",
        ];
        return (
            <div>
                {
                    forms.map((category, index) => {
                        if (!category.visible || !category.label || categoriesToExcludes.includes(category.name)) {
                            return <span key={index}></span>
                        }
                        if (category.name === "warrantyPeriod" || category.name === "warrantyPolicy") {
                            if (!productData["Warranty Type"] || productData["Warranty Type"] === "No Warranty") {
                                return <span key={index}></span>
                            }
                        }
                        return renderFormGroup(index, category);
                    })
                }
            </div>
        );
    }

    const onCategorySelect = (category: any) => {
        setIsCategoryLoading(true);
        setProductData((prevProductData: any) => ({
            nameEn: prevProductData.nameEn,
            nameUr: prevProductData.nameUr,
            categoryId: category._id,
            idPath: category.idPath || "",
        }));
        setSelectedCategory(category);
        setForms([]);
        dispatch(getCategoriesSelectFunc(category._id));
    }

    const handleDelete = () => {
        if (productId) {
            dispatch(deleteProduct({ productId, navigate }));
        } else if (draftId) {
            dispatch(deleteDraftProductApi({ id: draftId, navigate }));
        }
        setDeleteModal(false);
    };

    const isFormValid = () => {
        if (!isSubmitted) {
            setIsSubmitted(true);
        }
        const newErrors: { [key: string]: string } = {};
        const excludeFields = [
            "Brand",
        ];
        if (formRef.current) {
            const formElements = Array.from(formRef.current.elements) as HTMLInputElement[];
            for (let field of formElements) {
                if (field.name) {
                    if (field.tagName == "SELECT") {
                        if (field.required && !excludeFields.includes(field.name) && (field.value.includes('Select') || !field.value)) {
                            newErrors[field.name] = "This field is required.";
                        }
                    } else if (!field.checkValidity()) {
                        newErrors[field.name] = field.validationMessage; // HTML5 error message
                    }
                }

            }
            if (!productData.productImages || !productData.productImages.length) {
                newErrors['productImages'] = "Minimum 1 image is required.";
            }
            console.log(newErrors);
            setErrors(newErrors);
        }
        let isValid = true;

        if (!productData?.nameEn?.trim()) {
            setErrors((prevErrors: any) => ({ ...prevErrors, nameEn: true }));
            isValid = false;
        } else {
            setErrors((prevErrors: any) => ({ ...prevErrors, nameEn: false }));
        }

        if (Object.keys(newErrors)[0]) {
            let errorElem = document.getElementById(Object.keys(newErrors)[0]);
            if (errorElem) {
                errorElem.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }

        

        return Object.keys(newErrors).length === 0;
    };
    const onLocalDraftContinue = () => {
        const categoryForm = localStorage.getItem(StorageKeys.productCategoryForm) ? JSON.parse(localStorage.getItem(StorageKeys.productCategoryForm)!) : [];
        if (categoryForm && categoryForm.length) {
            setForms(categoryForm);
        } else {
            // toast.warning("Category would be added soon");
        }
        const prodData = localStorage.getItem(StorageKeys.productFormData) ? JSON.parse(localStorage.getItem(StorageKeys.productFormData)!) : {};
        if (prodData) {
            const categories = localStorage.getItem(StorageKeys.categories) ? JSON.parse(localStorage.getItem(StorageKeys.categories)!) : [];
            if (prodData.categoryId) {
                const selectedCategory = categories.find((x: any) => x._id === prodData.categoryId);
                if (selectedCategory) {
                    setSelectedCategory(selectedCategory);
                }
            }
            setProductData(prodData);
            if (prodData.nameUr) {
                setIsAdditionalField(true);
            }
        }

        const savedData = localStorage.getItem(StorageKeys.productFormData);
        if (savedData) {
            setProductData(JSON.parse(savedData));
        }

        setShowModal(false);
    };

    const handleDiscard = () => {
        localStorage.removeItem(StorageKeys.productCategoryForm)
        localStorage.removeItem(StorageKeys.productFormData);
        setProductData({ nameEn: "", nameUr: "", categoryId: "" });
        setShowModal(false);
    };



    return (
        <>
            {(location.pathname === "/product/add" || location.pathname === "/on-boarding") && (

                <Modal isOpen={showModal}>
                    <ModalBody>
                        <p>
                            You have unsaved data. Would you like to continue with your previous
                            entries or start fresh?
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-primary"  data-testing-id="continueButtonPop" onClick={onLocalDraftContinue}>
                            Continue
                        </button>
                        <button className="btn btn-danger" data-testing-id="discardButtonPop"  onClick={handleDiscard}>
                            Discard
                        </button>
                    </ModalFooter>
                </Modal>
            )}

            <form
                ref={formRef}
                onSubmit={(e) => {
                    e.preventDefault();
                    onProductSubmit();
                    // setTimeout(() => {
                    //     setLoader(false)    
                    // }, 1000);

                    return false;
                }}>
                <Card>
                    <CardBody>
                        <div className="formContainer ">
                            <Label className="form-label form_LabelTwo" htmlFor="product-title-input">
                                Product Name<sup className="text-danger fs-6">*</sup>
                                <AudioPlayer src="https://firebasestorage.googleapis.com/v0/b/cnc-hospital-7f706.appspot.com/o/test-upload%2FProductName.mp3?alt=media&token=9851d690-894a-40fe-aa8c-50dba88b090b" />
                            </Label>
                            <div className="d-flex align-items-center border boderGroup  pe-1" style={{ borderRadius: "11px" }}>
                                <Input
                                    type="text"
                                    className={`form-control pe-5 password-input ${(errors.nameEn) ? "is-invalid" : ""}`}
                                    id="product-title-input"
                                    placeholder="Ex. Nikon Coolpix A300 Digital Camera"
                                    data-testing-Id="productName_addProducts"
                                    name="nameEn"
                                    value={productData.nameEn}
                                    required
                                    onBlur={(e) => updateProductData('nameEn', e.target.value)}
                                    onChange={handleChange}

                                    maxLength={225}
                                />
                                <small className="text-muted">
                                    {productData.nameEn ? productData.nameEn.length : 0}/225
                                </small>

                            </div>
                            {aiData?.productName && showProductNameOption && !userDecisionMade && (
                            <div className=" orderDvYellow">
                                <div className=" d-flex justify-content-start align-items-center gap-1">
                                    <img src={star} alt="" />
                                <h6>Suggested By Buypass Ai  <span className="mdi mdi-information fs-5" style={{ color: "#97BEEE" }}></span></h6>
                                </div>
                                <p>{aiData.productName}</p>
                                <button
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                    updateProductData('nameEn', aiData.productName); // ✅ Apply value
                                    setUserDecisionMade(true);                      // hide option
                                }}
                                >
                                Use This Title
                                </button>
    {/* <button
      className="btn btn-danger btn-sm"
      onClick={() => {
        setUserDecisionMade(true);                      // ❌ No, just hide
      }}
    >
      ❌ No
    </button> */}
  </div>
)}

                            {errors.nameEn && (
                                <small className="text-danger">Please fill out this field.</small>
                            )}
                        </div>

                        {/* <a className="c-pointer d-flex align-items-center" onClick={togglenameUr}>Set Multiple Language <span className="mdi mdi-chevron-down"></span></a> */}
                        {isAdditionalField && <div className="formContainer ">
                            <Input
                                type="text"
                                className="form-control"
                                id="product-title-input"
                                placeholder="Enter product Name in Urdu"
                                data-testing-Id="multipleLanguage_addProducts"
                                name="nameUr"
                                value={productData.nameUr}
                                onBlur={(e) => updateProductData('nameUr', e.target.value)}
                                onChange={(e) => updateProductData('nameUr', e.target.value)}
                            />
                        </div>}
                        <CategorySelectInput initialCategory={selectedCategory} onCategorySelect={(category: any) => onCategorySelect(category)} />



                    </CardBody>
                </Card>

                {isCategoryLoading && <Loader />}

                {forms && renderForm(forms)}

                {!ref && productData.categoryId && !isCategoryLoading && <Card>
                    <CardBody>
                        <div className="d-flex justify-content-end">
                            {/* {productId && (<button
                                onClick={() => setDeleteModal(true)}
                                type="button"
                                className="btn btn-danger ml-auto"
                                data-testing-Id="delete_addProducts"
                                disabled={loader && true}
                            // className="btn btn-danger ml-auto mx-3"
                            >
                                Delete
                            </button>
                            )} */}
                            {draftId && user?.storeStatus?.isProductAdded && (<button
                                onClick={() => setDeleteModal(true)}
                                type="button"
                                className="btn btn-danger ml-auto"
                                data-testing-Id="delete_addProducts"
                                disabled={loader && true}
                            // className="btn btn-danger ml-auto mx-3"
                            >
                                Discard
                            </button>
                            )}
                            <DeleteModal
                                show={deleteModal}
                                onDeleteClick={handleDelete}
                                onCloseClick={() => setDeleteModal(false)}
                            />
                            {loader &&
                                <button
                                    type="submit"
                                    className="btn btn-primary "
                                >
                                    {/* <Loader color="warning" /> */}
                                    {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                </button>
                            }
                            {!loader && user?.storeStatus?.isProductAdded && !productId && productData.nameEn &&
                                <button
                                    onClick={onDraftSubmit}
                                    disabled={loader && true}
                                    type="button"
                                    className="btn btn-primary ms-3"
                                    data-testing-Id="draft_addProducts"
                                // className="btn btn-primary"
                                >
                                    {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}

                                    Save as Draft
                                </button>
                            }
                            {!loader &&
                                <button
                                    onClick={isFormValid}
                                    disabled={loader && true}
                                    type="submit"
                                    className="btn btn-primary ms-3"
                                    data-testing-Id="submit_addProducts"
                                // className="btn btn-primary"
                                >
                                    {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}

                                    Submit
                                </button>
                            }

                        </div>
                    </CardBody>
                </Card>}
                {ref && <button
                    style={{ display: "none" }}
                    disabled={loader}
                    ref={buttonRef}
                    type="submit"
                    className="btn btn-primary ml-auto ms-3"
                    data-testing-Id="submit_addProducts"
                // className="btn btn-primary ml-auto"
                >
                    Submit
                </button>}

            </form>
            <ErrorModal
                show={showModalColor.isVisible}
                message={errorMessageColor}
                color={showModalColor.color}
                onCloseClick={() => setShowModalColor({ isVisible: false, color: false })}
            />
            
        {user?.storeStatus && (
        <TermsPrivacyPopup
            show={termAndConditonModal}
            onCloseClick={() => setTermAndConditonModal(false)}
            type="terms"
            onAccepted={() => {
            acceptedFromPopupRef.current = true;
                setAccepted(true);
            setTermAndConditonModal(false);
            }}
        />
        )}

        </>
    );
});

export default AddProductStepOne;



